export const common = {
  clinicName: 'عيادة ريحان',
  home: 'الرئيسية',
  services: 'الخدمات',
  about: 'من نحن',
  news: 'الأخبار',
  gallery: 'المعرض',
  contact: 'اتصل بنا',
  recruitment: 'التوظيف',
  weAreHiring: 'نحن نوظف',
  callUs: 'اتصل بنا',
  makeAppointment: 'حجز موعد',
  ourServices: 'خدماتنا',
  sendMessage: 'إرسال الرسالة',
  sending: 'جاري الإرسال...',
  submit: 'إرسال',
  required: 'مطلوب',
  
  hero: {
    title: 'عيادة ريحان',
    subtitle: 'أول مؤسسة صحية خاصة حديثة في جيجل',
    description: 'تقنيات متطورة وفريق طبي مؤهل لرفاهيتك',
    emergencies: 'الطوارئ متاحة',
    qualifiedTeam: 'فريق مؤهل',
    qualifiedTeamDesc: 'أطباء متخصصون ذوو خبرة',
    modernEquipment: 'معدات حديثة',
    modernEquipmentDesc: 'تقنيات من أحدث جيل'
  },
  
  aboutSection: {
    title: 'عن عيادة ريحان',
    description1: 'عيادة ريحان هي أول مؤسسة صحية خاصة حديثة في جيجل، تقدم خدمات طبية عالية الجودة في بيئة مريحة وآمنة. تأسست برؤية تحويل الرعاية الصحية في المنطقة، وتلتزم عيادتنا بتقديم خدمات طبية متاحة وذات جودة عالية لجميع مرضانا.',
    description2: 'تقع في حي حين رشيد (بلحين)، تجمع عيادتنا بين التقنيات المتطورة والفريق الطبي المؤهل لضمان أفضل رعاية لمرضانا. نمتلك معدات طبية حديثة تشمل ماسح ضوئي من أحدث جيل، أجهزة تصوير بالموجات فوق الصوتية متقدمة، ومختبر تحاليل كامل. يعمل فريقنا متعدد التخصصات من الأطباء المتخصصين والطاقم الطبي المتفاني معًا لتقديم رعاية شاملة وشخصية.',
    description3: 'يتجلى التزامنا بالتميز في كل جانب من جوانب خدماتنا: من الاستقبال الحار لمرضانا إلى جودة رعايتنا الطبية، مرورًا براحة منشآتنا. نؤمن إيمانًا راسخًا بأن كل مريض يستحق اهتمامًا خاصًا ورعاية مصممة خصيصًا لتلبية احتياجاته الخاصة.',
    medicalExcellence: 'فريق طبي مؤهل',
    medicalExcellenceDesc: 'فريق من الأطباء المتخصصين ذوي المؤهلات العالية والخبرة',
    advancedTech: 'تقنيات متقدمة',
    advancedTechDesc: 'معدات طبية من أحدث جيل: ماسح ضوئي، تصوير بالموجات فوق الصوتية، مختبر',
    availability: 'توفر مستمر',
    availabilityDesc: 'خدمة الطوارئ مفتوحة لجميع احتياجاتك الطبية',
    emergencies: 'الطوارئ',
    specialties: 'التخصصات',
    dedicated: 'ملتزمون'
  },
  
  contactSection: {
    title: 'اتصل بنا',
    subtitle: 'فريقنا متاح للإجابة على أسئلتك',
    info: 'معلومات الاتصال',
    address: 'العنوان',
    addressValue: 'حي حين رشيد (بلحين)، جيجل 18000، الجزائر',
    phones: 'الهواتف',
    whatsapp: 'واتساب',
    whatsappDesc: '(الحجوزات والمعلومات)',
    email: 'البريد الإلكتروني',
    hours: 'أوقات العمل',
    hoursEmergency: 'الطوارئ: متاحة',
    hoursConsultation: 'الاستشارات: بموعد',
    followUs: 'تابعنا',
    sendMessageTitle: 'أرسل لنا رسالة',
    fullName: 'الاسم الكامل',
    phone: 'الهاتف',
    subject: 'الموضوع',
    selectSubject: 'اختر موضوعاً',
    appointment: 'حجز موعد',
    emergency: 'طوارئ طبية',
    information: 'معلومات',
    results: 'نتائج التحاليل',
    other: 'أخرى',
    message: 'الرسالة',
    messagePlaceholder: 'صف طلبك... (500 حرف كحد أقصى)',
    characters: 'حرف',
    successMessage: '✓ تم إرسال الرسالة بنجاح!',
    errorMessage: '✗ حدث خطأ. يرجى المحاولة مرة أخرى.'
  },
  
  footer: {
    description: 'أول مؤسسة صحية خاصة حديثة في جيجل. تكنولوجيا متطورة وفريق طبي مؤهل.',
    quickLinks: 'روابط سريعة',
    ourServices: 'خدماتنا',
    contactInfo: 'اتصل بنا',
    emergencies: 'الطوارئ: متاحة',
    consultations: 'الاستشارات: بموعد',
    rights: 'جميع الحقوق محفوظة.',
    poweredBy: 'مدعوم من Readdy',
    services: {
      emergencies: 'الطوارئ الطبية',
      consultations: 'الاستشارات',
      imaging: 'التصوير الطبي',
      gynecology: 'أمراض النساء والولادة',
      surgery: 'الجراحة',
      laboratory: 'المختبر',
      hospitalization: 'الاستشفاء'
    }
  }
};
